module.exports = __webpack_public_path__ + "assets/img/close.977024bb.png";